import Hero from "@/components/sections/Hero";
import DeeperProblem from "@/components/sections/DeeperProblem";
import Pathway from "@/components/sections/Pathway";
import BrandPhilosophy from "@/components/sections/BrandPhilosophy";
import CommunityTeaser from "@/components/sections/CommunityTeaser";
import AboutPreview from "@/components/sections/AboutPreview";
import Testimonials from "@/components/sections/Testimonials";
import FinalInvitation from "@/components/sections/FinalInvitation";

const Home = () => (
  <main data-testid="home-page">
    <Hero />
    <DeeperProblem />
    <Pathway />
    <BrandPhilosophy />
    <CommunityTeaser />
    <AboutPreview />
    <Testimonials />
    <FinalInvitation />
  </main>
);

export default Home;
